import { render, staticRenderFns } from "./productDeatail.vue?vue&type=template&id=6f05cf04&scoped=true&"
import script from "./productDeatail.vue?vue&type=script&lang=js&"
export * from "./productDeatail.vue?vue&type=script&lang=js&"
import style0 from "./productDeatail.vue?vue&type=style&index=0&id=6f05cf04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05cf04",
  null
  
)

export default component.exports